// observe for existence of #wcp_vd_table

new MutationObserver((mutations, observer) => {
  if (document.getElementById("wcp_vd_table")) {
    const wcpVdTableFirstRow = document.getElementById("wcp_vd_table").querySelector("table").querySelector("tbody").querySelector("tr");
    const wcpVdTableFirstRowHeadings = wcpVdTableFirstRow.querySelectorAll("th");
    if (wcpVdTableFirstRowHeadings.length > 0) {
      wcpVdTableFirstRowHeadings[0].textContent = "Množství";
      wcpVdTableFirstRowHeadings[1].textContent = "Sleva";
      wcpVdTableFirstRowHeadings[2].textContent = "Cena";
    }
    observer.disconnect();
  }
}).observe(document.body, {
  childList: true,
  subtree: true,
});
